export const Mydata = {
  data() {
    return {
      systemIds: [
        { id: "1", title: "Android" },
        { id: "2", title: "ios" },
        { id: "3", title: "小程序" },
      ],
      timeType: [
        { id: "1", title: "日" },
        { id: "2", title: "周" },
        { id: "3", title: "月" },
        { id: "4", title: "季" },
        { id: "5", title: "年" },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      dimensionalData: [
        {
          label: "日期",
          value: 1000,
          prop: "recovery_time",
          sortable: "custom",
          width: "120",
        },

        {
          label: "事业群",
          prop: "apartment_name",
          value: 1001,
        },
        {
          label: "部门",
          prop: "project_name",
          value: 1002,
        },
        {
          label: "项目",
          prop: "project_name",
          value: 1003,
        },
        {
          label: "应用",
          prop: "app_name",
          value: 1004,
        },
        {
          label: "系统",
          prop: "system_name",
          value: 1005,
        },
        {
          label: "投放渠道",
          prop: "channel",
          value: 1017,
        },
        {
          label: "投放平台",
          prop: "platform_name",
          value: 1019,
        },
        {
          label: "投放方式",
          prop: "invest_way_name",
          value: 1020,
        },
      ],
      AllsionalData: [
        {
          label: "发布时间",
          value: 1000,
          prop: "recovery_time",
          sortable: "custom",
          width: "120",
        },

        {
          label: "事业群",
          prop: "apartment_name",
          value: 1001,
        },
        {
          label: "部门",
          prop: "project_name",
          value: 1002,
        },
        {
          label: "项目",
          prop: "project_name",
          value: 1003,
        },
        {
          label: "应用",
          prop: "app_name",
          value: 1004,
        },
        {
          label: "系统",
          prop: "system_name",
          value: 1005,
        },
        {
          label: "投放渠道",
          prop: "channel",
          value: 1017,
        },
        {
          label: "投放平台",
          prop: "platform_name",
          value: 1019,
        },
        {
          label: "投放方式",
          prop: "invest_way_name",
          value: 1020,
        },
      ],
      // 表格
      column: [],
      // 分日回收
      real_column: [
        {
          label: "新增",
          prop: "device_new",
          sortable: "custom",
        },
        {
          label: "投稿消耗 (预估)",
          prop: "invest_cost",
          sortable: "custom",
        },
        {
          label: "1日回收",
          prop: "day1",
          sortable: "custom",
        },
        {
          label: "2日回收",
          prop: "day2",
          sortable: "custom",
        },
        {
          label: "3日回收",
          prop: "day3",
          sortable: "custom",
        },
        {
          label: "4日回收",
          prop: "day4",
          sortable: "custom",
        },
        {
          label: "5日回收",
          prop: "day5",
          sortable: "custom",
        },
        {
          label: "6日回收",
          prop: "day6",
          sortable: "custom",
        },
        {
          label: "7日回收",
          prop: "day7",
          sortable: "custom",
        },
        {
          label: "14日回收",
          prop: "day14",
          sortable: "custom",
        },
        {
          label: "30日回收",
          prop: "day30",
          sortable: "custom",
        },
        {
          label: "33日回收",
          prop: "day33",
          sortable: "custom",
        },
        {
          label: "37日回收",
          prop: "day37",
          sortable: "custom",
        },
        {
          label: "60日回收",
          prop: "day60",
          sortable: "custom",
        },
        {
          label: "63日回收",
          prop: "day63",
          sortable: "custom",
        },
        {
          label: "67日回收",
          prop: "day67",
          sortable: "custom",
        },
        {
          label: "90日回收",
          prop: "day90",
          sortable: "custom",
        },
        {
          label: "180日回收",
          prop: "day180",
          sortable: "custom",
        },
        {
          label: "365日回收",
          prop: "day365",
          sortable: "custom",
        },
        {
          label: "1日ROI",
          prop: "roi1",
        },
        {
          label: "2日ROI",
          prop: "roi2",
        },
        {
          label: "3日ROI",
          prop: "roi3",
        },
        {
          label: "4日ROI",
          prop: "roi4",
        },
        {
          label: "5日ROI",
          prop: "roi5",
        },
        {
          label: "6日ROI",
          prop: "roi6",
        },
        {
          label: "7日ROI",
          prop: "roi7",
        },
        {
          label: "14日ROI",
          prop: "roi14",
        },
        {
          label: "30日ROI",
          prop: "roi30",
        },
        {
          label: "33日ROI",
          prop: "roi33",
        },
        {
          label: "37日ROI",
          prop: "roi37",
        },
        {
          label: "60日ROI",
          prop: "roi60",
        },
        {
          label: "63日ROI",
          prop: "roi63",
        },
        {
          label: "67日ROI",
          prop: "roi67",
        },
        {
          label: "90日ROI",
          prop: "roi90",
        },
        {
          label: "180日ROI",
          prop: "roi180",
        },
        {
          label: "365日ROI",
          prop: "roi365",
        },
      ],
      // 总回收
      paper_column: [
        {
          label: "新增",
          prop: "device_new",
          sortable: "custom",
        },
        {
          label: "总投放金额",
          prop: "invest_cost",
          sortable: "custom",
        },
        {
          label: "1日回收",
          prop: "day1",
          sortable: "custom",
        },
        {
          label: "2日回收",
          prop: "day2",
          sortable: "custom",
        },
        {
          label: "3日回收",
          prop: "day3",
          sortable: "custom",
        },
        {
          label: "4日回收",
          prop: "day4",
          sortable: "custom",
        },
        {
          label: "5日回收",
          prop: "day5",
          sortable: "custom",
        },
        {
          label: "6日回收",
          prop: "day6",
          sortable: "custom",
        },
        {
          label: "7日回收",
          prop: "day7",
          sortable: "custom",
        },
        {
          label: "14日回收",
          prop: "day14",
          sortable: "custom",
        },
        {
          label: "30日回收",
          prop: "day30",
          sortable: "custom",
        },
        {
          label: "33日回收",
          prop: "day33",
          sortable: "custom",
        },
        {
          label: "37日回收",
          prop: "day37",
          sortable: "custom",
        },
        {
          label: "60日回收",
          prop: "day60",
          sortable: "custom",
        },
        {
          label: "63日回收",
          prop: "day63",
          sortable: "custom",
        },
        {
          label: "67日回收",
          prop: "day67",
          sortable: "custom",
        },
        {
          label: "90日回收",
          prop: "day90",
          sortable: "custom",
        },
        {
          label: "180日回收",
          prop: "day180",
          sortable: "custom",
        },
        {
          label: "365日回收",
          prop: "day365",
          sortable: "custom",
        },
        {
          label: "1日ROI",
          prop: "roi1",
        },
        {
          label: "2日ROI",
          prop: "roi2",
        },
        {
          label: "3日ROI",
          prop: "roi3",
        },
        {
          label: "4日ROI",
          prop: "roi4",
        },
        {
          label: "5日ROI",
          prop: "roi5",
        },
        {
          label: "6日ROI",
          prop: "roi6",
        },
        {
          label: "7日ROI",
          prop: "roi7",
        },

        {
          label: "14日ROI",
          prop: "roi14",
        },
        {
          label: "30日ROI",
          prop: "roi30",
        },
        {
          label: "33日ROI",
          prop: "roi33",
        },
        {
          label: "37日ROI",
          prop: "roi37",
        },
        {
          label: "60日ROI",
          prop: "roi60",
        },
        {
          label: "63日ROI",
          prop: "roi63",
        },
        {
          label: "67日ROI",
          prop: "roi67",
        },
        {
          label: "90日ROI",
          prop: "roi90",
        },
        {
          label: "180日ROI",
          prop: "roi180",
        },
        {
          label: "365日ROI",
          prop: "roi365",
        },
      ],
    };
  },
};
